import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

export const StyledSoundCloudContainer = styled.div`
  margin: ${pxToRem(20)};
`
